import React, { useContext } from 'react';
import { Link, useHistory } from 'react-router-dom';
import styled from 'styled-components';

import { Logo } from '../atom/Logo';
import Icon from '../atom/Icon';
import { Button } from '../atom/Button';
import { Text } from '../atom/Text';
import { Copyright } from '../atom/Copyright';
import { Flex } from '../atom/Layout';
import { ModalBackground } from './Modal';
import EventReviewContestIcon, {
  isReviewContestOn,
} from '../../../lib/image/event/EventReviewContestIcon';
import * as PATH from '../../../lib/routes/path';
import ThemeStyle from '../../../lib/style/ThemeStyle';
import DrawerContext from '../../../modules/contexts/DrawerContext';
import AuthContext from '../../../modules/contexts/Auth';
import {
  ACCOUNT_MENU,
  MYPAGE_PATH_LOGGED,
  PAYBACK_MENU,
} from '../../../lib/routes/MyPageRoutes';

export const Drawer = () => {
  const {
    actions: { onDrawer },
  } = useContext(DrawerContext);

  const {
    state: { logged, isLoading },
    actions: { signout },
  } = useContext(AuthContext);

  const history = useHistory();

  const deawerPath = [
    BRAND_STORY_MENU,
    BABYFACE_DETAIL_MENU,
    CLEARFACE_DETAIL_MENU,
    BLOG_MENU,
    logged ? PAYBACK_MENU : INVITE_FRIEND_MENU,
    EVENT_MENU,
  ];

  const AuthContainer = () => (
    <>
      <OrangePinkContainer column alignItems="stretch">
        <Flex justifyContent="space-between">
          <Logo white={+true} />
          <Icon
            iconName="close"
            onClick={onDrawer}
            style={{ color: ThemeStyle.color.background }}
          />
        </Flex>
        <Flex padding="1.25rem 0.625rem 0">
          {(logged ? BUTTON_PATH_LOGGED : BUTTON_PATH).map((button) => (
            <Button
              key={button.label}
              color="background"
              style={{
                margin: '5px',
                cursor: 'pointer',
                height: '2.5rem',
              }}
              isLoading={button.label === '로그아웃' && isLoading}
              onClick={
                button.label === '로그아웃'
                  ? () => signout().then(() => onDrawer)
                  : () => {
                      history.push(button.path);
                      onDrawer();
                    }
              }
            >
              <Text size={12}>{button.label}</Text>
            </Button>
          ))}
        </Flex>

        {/* {logged ? (
          <Flex column alignItems="stretch" padding={`${SizeToRem(20)} 0 0`}>
            <Flex
              padding={`${SizeToRem(10)} ${SizeToRem(20)} `}
              style={{
                borderRadius: '6px',
                background: ThemeStyle.background.white,
              }}
            >
              <Text>님, 안녕하세요!</Text>
            </Flex>
            <Flex justifyContent="flex-end" padding={`${SizeToRem(20)} 0 0`}>
              {BUTTON_PATH_LOGGED.map((button) =>
                button.label !== '로그아웃' ? (
                  <TextLink
                    key={button.label} 
                    link={button.path}
                    color="background"
                    withUnderline
                    style={{ marginLeft: SizeToRem(20) }}
                    onClick={() => {
                      onDrawer();
                    }}
                  >
                    {button.label}
                  </TextLink>
                ) : (
                  <Text
                    onClick={() => {
                      signout();
                      onDrawer();
                    }}
                    color="background"
                    style={{
                      textDecoration: 'underline',
                      marginLeft: SizeToRem(20),
                    }}
                  >
                    {button.label}
                  </Text>
                ),
              )}
            </Flex>
          </Flex>
        ) : (
          <Flex padding={`${SizeToRem(20)} ${SizeToRem(10)} 0`}>
            {BUTTON_PATH_LOGGED.map((button) => (
              <Button
                key={button.label}
                color="background"
                style={{
                  margin: '5px',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  button.label === '로그아웃'
                    ? signout()
                    : history.push(button.path);
                  onDrawer();
                }}
              >
                <Text size={12}>{button.label}</Text>
              </Button>
            ))}
          </Flex>
        )} */}
      </OrangePinkContainer>
      {logged && (
        <Flex
          padding={`${
            isReviewContestOn() ? '2.25' : '1.25'
          }rem 1.875rem 1.25rem`}
          justifyContent="space-between"
          width="100%"
          style={{ background: ThemeStyle.background.white }}
        >
          {MYPAGE_PATH_LOGGED.map((data) => (
            <Flex column style={{ position: 'relative' }} key={data.label}>
              {data.label === '리뷰관리' && (
                <Flex style={{ position: 'absolute', top: '-1.9rem' }}>
                  <EventReviewContestIcon />
                </Flex>
              )}
              <Flex
                column
                onClick={() => {
                  history.push(data.path);
                  onDrawer();
                }}
              >
                {/* <Text
              color="orangePink"
              style={{ marginBottom: SizeToRem(20) }}
              weight="medium"
            >
              {data.count}
            </Text> */}
                <Text size={14} weight="medium">
                  {data.label}
                </Text>
              </Flex>
            </Flex>
          ))}
        </Flex>
      )}
    </>
  );

  return (
    <ModalBackground justifyContent="flex-end">
      <DrawerContainer column justifyContent="flex-start">
        <AuthContainer />
        <Flex
          column
          width="100%"
          justifyContent="flex-start"
          style={{ overflowY: 'scroll' }}
        >
          <Flex
            column
            padding="0.625rem 0 0"
            style={{
              width: '100%',
              margin: '0.625rem 0',
              background: ThemeStyle.background.white,
            }}
          >
            {deawerPath.map((data) => (
              <LinkButon
                key={data.label}
                to={data.path}
                onClick={onDrawer}
                nobottom={data === deawerPath[deawerPath.length - 1] ? 1 : 0}
              >
                <Text size={14}>
                  {data.label}
                  {(data.label === '친구초대' ||
                    data.label === '친구추천코드') && (
                    <Text
                      size={10}
                      color="orangePink"
                      style={{ marginLeft: '0.5625rem' }}
                    >
                      친구초대하고 페이백 받기!
                    </Text>
                  )}
                </Text>

                <Icon
                  iconName="arrow_forward_ios"
                  style={{ color: ThemeStyle.color.brownGrey }}
                />
              </LinkButon>
            ))}
          </Flex>
          <Flex
            style={{
              width: '100%',
              height: '100%',
              background: ThemeStyle.background.white,
            }}
            padding="1rem 0"
          >
            <Copyright />
          </Flex>
        </Flex>
      </DrawerContainer>
    </ModalBackground>
  );
};

const DrawerContainer = styled(Flex)`
  width: 17.5rem;
  height: 100%;
  background: ${(props) => props.theme.background.grey};
  border-radius: 7px 0 0 7px;
  overflow-y: scroll;
  z-index: 102;
`;

const OrangePinkContainer = styled(Flex)`
  width: 100%;
  padding: 1.25rem;
  background: ${(props) => props.theme.color.orangePink};
  border-top-left-radius: 7px;
`;

const LinkButon = styled(Link)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: ${(props) =>
    props.nobottom ? 'none' : `1px solid ${props.theme.color.pinkishGrey}`};
  width: 100%;
  padding: 1.25rem;
`;

export const EVENT_MENU = { label: '이벤트', path: PATH.EVENT };
export const BLOG_MENU = { label: '블로그', path: PATH.BLOG };
export const BABYFACE_DETAIL_MENU = { label: '베이비페이스', path: PATH.SALES };
export const CLEARFACE_DETAIL_MENU = {
  label: '클리어페이스',
  path: PATH.SALES_CLEARFACE,
};
export const SIGN_UP_MENU = {
  label: '회원가입',
  path: PATH.SIGNIN,
};
export const SIGN_IN_MENU = {
  label: '로그인',
  path: PATH.SIGNIN,
};
export const LOGOUT_MENU = {
  label: '로그아웃',
  path: PATH.MYPAGE,
};
export const BRAND_STORY_MENU = {
  label: '브랜드 스토리',
  path: PATH.BRAND_STORY,
};
export const INVITE_FRIEND_MENU = {
  label: '친구초대',
  path: `${PATH.EVENT_DETAIL}/friend`,
};

const BUTTON_PATH = [SIGN_IN_MENU, SIGN_UP_MENU];

const BUTTON_PATH_LOGGED = [ACCOUNT_MENU, LOGOUT_MENU];
